import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="text-white pt-6 pb-2 px-3 md:pt-12 md:pb-4 bg-radial-glow relative overflow-hidden" data-id="element-169">
      <div className="max-w-xl mx-auto text-center relative z-10" data-id="element-170">
        <div className="animate-fadeInUp" data-id="element-171">
          {/* Small badge */}
          <div className="inline-block bg-brand-yellow/10 text-brand-yellow px-4 py-1.5 rounded-full text-xs font-bold mb-4 border border-brand-yellow/20 tracking-wide backdrop-blur-sm" data-id="element-172">
            👩‍⚕️ SISTEMA COMPLETO PARA DOMINAR LA FARMACOLOGÍA EN LA PRÁCTICA
            DESDE HOY
          </div>

          {/* Main headline */}
          <h1 className="text-[2rem] md:text-5xl lg:text-6xl font-extrabold leading-[1.1] mb-3 px-0 text-white" data-id="element-173">
            👉 Empezá a medicar con claridad…{' '}
            <span className="text-brand-yellow" data-id="element-174">sin dudar</span>
          </h1>

          {/* Product image */}
          <div className="relative mb-6 max-w-lg mx-auto" data-id="element-175">
            <div className="absolute inset-0 bg-brand-blue-clinical/20 blur-[100px] rounded-full -z-10" data-id="element-176" />
            <img src="https://cdn.magicpatterns.com/uploads/qpreTYVv97oMaHWiBewHXJ/MOCKUP_FINAL_600x.png" alt="Mega Pack Farmacología Lista™" fetchPriority="high" loading="eager" width="600" height="450" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.3)] hover:scale-[1.01] transition-transform duration-700" data-id="element-177" />
          </div>

          {/* Yellow highlight text */}
          <p className="text-base md:text-lg font-medium italic mb-6 max-w-sm mx-auto leading-snug text-gray-300" data-id="element-178">
            Listo para aplicar. Sin dudas constantes. Sin miedo a equivocarte.
            Sin sentir que estás improvisando cada vez que tenés que medicar…
          </p>

          {/* Full-width CTA */}
          <CTAButton text="👉 QUIERO EMPEZAR A MEDICAR CON SEGURIDAD HOY" className="w-auto mx-auto mb-5 py-3 px-6 text-sm md:text-base font-black rounded-xl" data-id="element-179" />

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs text-gray-500" data-id="element-180">
            <div className="flex items-center gap-1" data-id="element-181">
              <ShieldCheck size={14} className="text-brand-yellow" data-id="element-182" />
              <span data-id="element-183">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-184">
              <Lock size={14} className="text-brand-yellow" data-id="element-185" />
              <span data-id="element-186">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-187">
              <CreditCard size={14} className="text-brand-yellow" data-id="element-188" />
              <span data-id="element-189">Pagás en pesos argentinos</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}